<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import { RouterLink } from 'vue-router'

import type { NavigationItem } from '@/models/navigation'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  item: NavigationItem
}>()

const attrs = useAttrs()
const internalTarget = computed(() => props.item.relativeUrl || (
  props.item.url.startsWith('/') ? props.item.url : ''
))
const externalTarget = computed(() => internalTarget.value ? '' : props.item.url)
const linkTarget = computed(() => props.item.target || undefined)
const linkRel = computed(() => {
  const values = props.item.rel.split(/\s+/).filter(Boolean)

  if (linkTarget.value === '_blank' && !values.includes('noopener')) {
    values.push('noopener')
  }

  return values.length ? values.join(' ') : undefined
})
</script>

<template>
  <RouterLink
    v-if="internalTarget"
    :to="internalTarget"
    :target="linkTarget"
    :rel="linkRel"
    v-bind="attrs"
  >
    <slot />
  </RouterLink>
  <a
    v-else-if="externalTarget"
    :href="externalTarget"
    :target="linkTarget"
    :rel="linkRel"
    v-bind="attrs"
  >
    <slot />
  </a>
  <span
    v-else
    v-bind="attrs"
  >
    <slot />
  </span>
</template>
